import api from "../..";
import type { ApiResponse } from "../../types";
import type { CategoryResponse, PatchCategoryParams } from "./types";

export const patchCategory = async ({ id, body }: PatchCategoryParams): Promise<boolean> => {

  return await api.patch<ApiResponse<CategoryResponse>>(`/category/${id}/`, body)
  .then(() => true)
  .catch(() => false);
};